import { Stack, Text, VStack } from '@genial/components';
import React from 'react';

import { TextSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const UnitPriceInfo: React.FC<FixedIncomeSharedInfoTypes> = ({ selectedFee, offer, w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Preço unitário</Text>
        <Text>{selectedFee?.customerPuAmountFormatted || offer.unitPriceNormalized || '--'}</Text>
      </VStack>
    </Stack>
  );
};

export const UnitPriceInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Preço unitário</Text>
        <TextSkeleton />
      </VStack>
    </Stack>
  );
};
